export default {
    "open_equity": "Alustades omakapitali",
    "bonus": "Boonus",
    "closed_positions": "Suletud positsioonid",
    "finance": "Rahandus",
    "watchlist": "Jälgimisnimekiri",
    "calendar": "Kalender",
    "symbol_information": "Sümboli teave",
    "contact_size": "Kontaktide suurus",
    "min_tick_size": "Min Tick suurus",
    "min_lot": "Min partii",
    "max_lot": "Maksimaalne partii",
    "pip_size": "Pip suurus",
    "stop_limit_levels": "Stopp- ja piirnormid",
    "base_currency": "Tsitaat Valuuta",
    "swap_type": "Vahetuse tüüp",
    "digits": "Numbrid",
    "trade_id": "Kaubanduse ID",
    "sell_buy": "Müüa/osta",
    "instrument": "Instrument",
    "open_current_price": "Avatud/jooksev hind",
    "s_slash_l": "S/L",
    "profit_slash_loss": "Kasum/kahjum",
    'net_pl':'Neto P/L',
    "comment": "Kommentaar",
    "action": "Tegevus",
    "proximity": "Proximity",
    "buy_stop": "Osta Stopp",
    "buy_limit": "Osta limiit",
    "stop_loss": "Stop Loss",
    "rate": "Hinda",
    "take_profit": "Võtke kasumit",
    "price": "Hind",
    "maximum_20_characters": "Maksimaalselt 20 tähemärki",
    "btn_place_buy_order": "Tee ostutellimus",
    "btn_place_sell_order": "Müüa tellimus",
    "change": "Muuda",
    "descrption": "Kirjeldus",
    "asset_class": "Varaklass",
    "subclass": "Alamklass",
    "major": "Major",
    "size_of_1_pip": "1 pipi suurus",
    "Min_position_size": "Min. Positsioon Suurus",
    "Max_position_size": "Max. Positsioon Suurus",
    "leverage": "Finantsvõimendus",
    "daily_swap_points": "Igapäevased vahetuspunktid",
    "long": "Pikk",
    "short": "lühike",
    "market_hours_local_time": "Turu lahtiolekuajad (kohaliku aja järgi)",
    "main_trading": "Main/Trading",
    "copy_trade": "Copy Trade",
    "view_modes": "Vaade režiimid",
    "reports": "Aruanded",
    "pivot_table": "Pivot tabel",
    "pp": "PP",
    "s1": "S1",
    "s2": "S2",
    "s3": "S3",
    "r1": "R1",
    "r2": "R2",
    "r3": "R3",
    "list_property": "Loetelu Kinnisvara",
    "overview": "Ülevaade",
    "day_low": "Päev madal",
    "prev_close": "Eelmine Sulge",
    "day_high": "Päeva kõrghoone",
    "52_week_low": "52 nädala madalseis",
    "1_day_range": "1 päevane vahemik",
    "52_day_range": "52-päevane vahemik",
    "daily": "Igapäevane",
    "weekly": "Nädalane",
    "monthly": "Igakuiselt",
    "moving_averages": "Liikuvad keskmised",
    "technical_indicators": "Tehnilised näitajad",
    "charts": "Graafikud",
    "trade_log": "Kaubanduspäevik",
    "create_new_watchlist": "Uue jälgimisnimekirja loomine",
    "net_profit": "Puhaskasum",
    "maximum_equity_drawdown": "Maksimaalne omakapitali mahakandmine",
    "profit_percentage": "Kasumi protsent",
    "opening_balance": "Alustades tasakaalu",
    "current_balance": "Praegune saldo",
    "deposit": "Tagatisraha",
    "withdrawal": "Tagasivõtmine",
    "economic_calendar": "Majanduskalender",
    "dashboard": "Armatuurlaud",
    "markets": "Turud",
    "portfolio": "Portfoolio",
    "buzz": "Buzz",
    "view_profile": "Vaata profiili",
    "equity": "Omakapital",
    "realized_profit": "Realiseeritud kasum",
    "unrealized_profit": "Realiseerimata kasum",
    "balance": "Saldo",
    "used_margin": "Kasutatud marginaal",
    "free_margin": "Vaba marginaal",
    "profile": "Profiil",
    "settings": "Seaded",
    "theme": "Teema",
    "logout": "Väljalogimine",
    "trading_account": "Kauplemiskonto",
    "quick_links": "Kiirlinke",
    "back": "Tagasi",
    "previous": "Eelmine",
    "forecast": "Prognoos",
    "actual": "Tegelik",
    "data": "Kuupäev",
    "margin_level": "Marginaali tase",
    "news": "Uudised",
    "unrealised_pl": "REALISEERIMATA NETOPOSITSIOONID",
    "unrealised_gross_pl": "REALISEERIMATA BRUTOPOSITSIOONID",
    "quantity": "Kogus",
    "trailing_sl": "Tagasiulatuv SL",
    "sell": "Müüa",
    "buy": "Osta",
    "open_positions": "Avatud ametikohad",
    "close_all_profitable": "Sulge kõik kasumlikud",
    "close_all_losing": "Sulge kõik kaotavad",
    "close_all_buy": "Sulge kõik Osta",
    "close_all_sell": "Sulge kõik Müüa",
    "no": "Ei",
    "yes": "Jah",
    "are_you_sure": "Kas olete kindel, et soovite",
    "current_market_rates": "praeguste turuhindadega?",
    "close_all": "Sulge kõik",
    "watchlists": "Jälgimisnimekirjad",
    "default": "Vaikimisi",
    "add_new_watchlist": "Lisa uus jälgimisnimekiri",
    "delete_watchlist?": "Kas olete kindel, et soovite selle jälgimisnimekirja kustutada?",
    "cancel": "Tühista",
    "delete": "Kustuta",
    "delete_alert": "Kas olete kindel, et soovite selle teate kustutada?",
    "condition": "Tingimus",
    "triggered": "Triggerdatud",
    "active": "Aktiivne",
    "alert": "Hoiatus",
    "alerts": "Hoiatused",
    "going_below": "Allapoole minek",
    "going_above": "Ülespoole minek",
    "bid_price": "Pakkumise hind",
    "ask_price": "Küsi hinda",
    "symbol": "Sümbol",
    "edit_alert": "Edit Alert",
    "create_alert_on": "Loo hoiatus aadressil",
    "info": "Info",
    "daily_range": "Päevane vahemik",
    "spread": "Levita",
    "contract_size": "Lepingu suurus",
    "min_trade_size": "Min kaubanduslik suurus",
    "max_trade_size": "Maksimaalne kaubanduse suurus",
    "swap_long": "Vaheta pikk",
    "swap_short": "Vaheta lühike",
    "create_alert": "Hoiatuse loomine",
    "remove_watchlist": "Eemalda jälgimisnimekirjast",
    "trading_view_chart": "Kaubanduse vaade Diagramm",
    "chart": "Graafik",
    "add": "Lisa",
    "add_instruments_watchlist": "Lisage vahendid oma jälgimisnimekirja",
    "h": "H",
    "l": "L",
    "cryptos": "Cryptos",
    "indices": "Indeksid",
    "forex": "Forex",
    "fx": "FX",
    "stocks": "Varud",
    "comm": "Comm",
    "commodities": "Tooraine",
    "low": "Madal",
    "high": "Kõrge",
    "change_percentage": "Muutus %",
    "bid": "Pakkumine",
    "ask": "Küsi",
    "order": "Tellige",
    "commission": "Komisjon",
    "swap": "Vahetus",
    "open_date": "Avatud kuupäev",
    "lots": "Palju",
    "b_slash_s": "B/S",
    "open_price": "Avatud hind",
    "order_price": "Tellige hind",
    "current_price": "Praegune hind",
    "comments": "Kommentaarid",
    "modify": "Muuda",
    "close": "Sulge",
    "ok": "Ok",
    "trailing_stop": " Jälgitav stopp",
    "trailing_stop_loss": "Jälgitav Stop Loss",
    "quntity": "Quntity",
    "price_level": "Hinnatase",
    "type": "Tüüp",
    "trades": "Tehingud",
    "order_id": "Tellimuse ID",
    "modify_order": "Muuda tellimust",
    "revert": "Tagasi",
    "id": "ID",
    "sl": "SL",
    "tp": "TP",
    "close_order": "Sulge tellimus",
    "trail_s_slash_l": "Rada S/L",
    "pnl_s": "Pnl",
    "direction": "Suund",
    "modify_position": "Muuda positsiooni",
    "close_price": "Sulge hind",
    "close_date": "Sulge kuupäev",
    "total_p_slash_l": "Kokku P/L",
    "place_new_order": "Asetage uus tellimus",
    "close_time": "Sulge aeg",
    "open_time": "Avatud aeg",
    "p_slash_l": "P/L",
    "reason": "Põhjus",
    "qty": "Kogus",
    "pending_orders": "Olemasolevad tellimused",
    "order_type": "Tellimuse tüüp",
    "close_all_orders": "Kas olete kindel, et soovite kõik avatud tellimused sulgeda?",
    "place_order": "Tee tellimus",
    "advanced_options": "Täiustatud valikud",
    "available_margin": "Kättesaadav marginaal",
    "trade": "Kaubandus",
    "positions": "Positsioonid",
    "orders": "Tellimused",
    "history": "Ajalugu",
    "summary": "Kokkuvõte",
    "summary_from": "Kokkuvõte Alates:",
    "performance": "Tulemuslikkus",
    "profitability": "Kasumlikkus",
    "password_validation": "Parool peab olema vähemalt 8 tähemärki pikk, üks erimärk, üks täht, üks number.",
    "note": "Märkus",
    "change_password": "Muuda salasõna",
    "submit": "Esita",
    "select_server_type": "Valige serveri tüüp",
    "create_demo_account": "Demokonto loomine",
    "create_new_account": "Uue konto loomine",
    "account_id": "Konto ID",
    "name": "Nimi",
    "currency": "Valuuta",
    "security": "Turvalisus",
    "amount": "Summa",
    "select_leverage": "Valige finantsvõimendus",
    "select_currency": "Valige valuuta",
    "save_settings": "Salvesta seaded",
    "large": "Suur",
    "small": "Väike",
    "font_size": "Kirjasuurus",
    "units": "Üksused",
    "select_show": "Valige Show",
    "order_position_size": "Tellimus / positsioon Suurus In",
    "custom": "Kohandatud",
    "month": "Kuu",
    "days": "Päevad",
    "day": "Päev",
    "select": "Valige",
    "history_range": "Ajalooline vahemik",
    "default_lot_size": "Vaikimisi krundi suurus",
    "local_time": "Kohalik aeg",
    "server": "Server",
    "timezone": "Ajavöönd",
    "enable": "Lubage",
    "modify_trade": "Muuda kaubandust",
    "open": "Avatud",
    "enter_quantity": "Sisestage kogus",
    "tooltip": "Tooltip",
    "field": "Väli",
    "value": "Väärtus",
    "date_time": "Kuupäev/kellaaeg",
    "market": "Turg",
    "all": "Kõik",
    "verify": "Kontrollida",
    "volume": "Köide",
    "lot": "partii",
    "quantity_required": " Vajalik on kogus.",
    "stop_loss_required": " Vajalik on stop loss.",
    "distance_points": "Kaugus praegusest hinnast",
    "points": "Punktid",
    "back_to_login": "Tagasi sisselogimise juurde",
    "forgot_password": "Unustasid salasõna?",
    "enter_username": "Sisestage kasutajanimi",
    "login": "Logi sisse",
    "remember_me": "Mäleta mind",
    "login_another_account": "Sisene teise kontoga",
    "2fa_verification": "2FA kontrollimine",
    "my_profile": "Minu profiil",
    "user_name": "Kasutaja nimi",
    "email": "E-post",
    "already_have_account": " Kas teil on juba konto?",
    "register": "Registreeri",
    "last_name": "Perekonnanimi",
    "first_name": "Eesnimi",
    "password": "Parool",
    "disable_two_factor_auth": "Kahefaktorilise autentimise väljalülitamine",
    "enter_6_digit_code": "Sisestage genereeritud 6-kohaline kinnituskood.",
    "enable_two_factor_authentication": "Kahefaktorilise autentimise lubamine",
    "please_click_2fa_enable": "Palun klõpsake 2FA-valikul, mida soovite lubada.",
    "download_authenticator_app": "Lae alla autentimisrakendus",
    "download_install_google_authenticator": "Laadige alla ja installige Authy või Google Authenticator oma telefoni või tahvelarvutisse.",
    "scan_code": "Skaneeri QR-koodi",
    "open_authentication_app_camera": "Avage autentimisrakendus ja skaneerige telefoni kaameraga vasakpoolset pilti.",
    "login_code": "Logi sisse oma koodiga",
    "two_factor_authentication": "Kahefaktoriline autentimine",
    "2fa_already_enabled": "2FA on juba sisse lülitatud Palun klõpsake 2FA-valikut, mille soovite välja lülitada.",
    "usd": "USD",
    "eur": "EUR",
    "gbp": "GBP",
    "aud": "AUD",
    "enter_6_digit_code_placeholder": "Sisestage 6-kohaline kood",
    "enter_google_verification_code": "Sisestage Google'i kinnituskood",
    "trading_id_placeholder": "Sisestage oma kaubandustunnus",
    "password_placeholder": "Sisestage oma parool",
    "email_placeholder": "Sisestage oma e-posti aadress",
    "enter_old_password": "Sisestage praegune parool",
    "enter_new_password": "Sisestage uus parool",
    "enter_new_password_again": "Sisestage uus parool uuesti",
    "alpha_numeric_dashes_underscores_spaces": "väli võib sisaldada ainult tähtnumbrilisi märke, samuti kriipsu, alatähti ja tühikuid.",
    "is_required": "on nõutav",
    "field_must_be": " väli peab olema",
    "or_more": "on või rohkem.",
    "or_less": "on või vähem.",
    "must_be_greater_then": "peab siis olema suurem.",
    "must_be_less_then": "peab olema väiksem kui",
    "not_valid": "ei kehti",
    "buy_stop_loss_error_message": "Stop Loss peab olema väiksem kui turuhind",
    "trailing_stop_required": "Vajalik on järelpeatus.",
    "trailing_stop_greater_zero": "Tagasiulatuv stop peab olema suurem kui",
    "target_price_required": "Vajalik on sihthind.",
    "target_price_greater_trigger": "Sihthind peaks olema suurem kui praegune hind ja",
    "trigger_price": "Trigger Hind",
    "price_required": "Hind on nõutav.",
    "price_must_be_greater_than": "Hind peab olema suurem kui",
    "target_price_greater_price_level": "Sihthind peab olema suurem kui hinnatase",
    "price_must_be_less_than": "Hind peab olema väiksem kui",
    "and_greater_than_zero": "ja suurem kui",
    "stop_loss_less_price_level_greater_zero": "Stop loss peab olema väiksem kui Price Level ja suurem kui",
    "target_price_less_trigger": "Sihthind peaks olema väiksem kui praegune hind ja suurem kui",
    "sell_stop": "Müü Stopp",
    "sell_limit": "Müüa limiit",
    "sell_stop_loss_error_message": "Stop Loss peab olema suurem kui turuhind",
    "placed_order_pending_wait": "Teie esitatud tellimus on ootab, palun oodake",
    "place_other_order": "Muude tellimuste paigutamine",
    "no_account_id_found": "Konto ID puudub",
    "target_price_must_less_than_trigger_price_greater_zero": "Sihthind peab olema väiksem kui vallandamishind ja suurem kui",
    "sell_stop_loss_greater_trigger_price": "Stop Loss peab olema suurem kui käivitushind",
    "create_new_alert": "Uue hoiatuse loomine",
    "losing": "Kaotamine",
    "winning": "Winning",
    "avg_trade_size": "Keskmine kaubanduse suurus",
    "asset": "Varad",
    "trades_lost": "Kaotatud tehingud",
    "trades_won": "Võidetud tehingud",
    "total_trades": "Kauplemine kokku",
    "total_trading_volume": "Kauplemismaht kokku",
    "resend": "Saada uuesti",
    "reset_password_msg": "Palun kontrollige e-posti aadressi, et saada juhiseid oma salasõna lähtestamiseks.",
    "server_type": "Serveri tüüp",
    "check_email": "Kontrollige oma e-posti aadressi",
    "technicals": "Tehnilised andmed",
    "disable": "Lülita välja",
    "amount_greater_100000": "Summa ei tohiks olla suurem kui 100000",
    "x": "X",
    "password_required": "Vajalik on salasõna.",
    "proceed": "Jätkake",
    "turnkey_forex": "TurnkeyForex",
    "coinexx": "Coinexx",
    "finpro_trading": "Finpro Trading",
    "hankotrade": "Hankotrade",
    "brokers": "Maaklerid",
    "select_broker": "Vali maakler",
    "edit_price_alert": "Muuda hinnahoiatus",
    "create_price_alert": "Hinnahoiatuse loomine",
    "maximum_100_characters": "Maksimaalselt 100 tähemärki",
    "add_comment": "Lisa kommentaar",
    "price_must_be": "Hind peab olema",
    "then": "siis",
    "crossing_above": "Ületamine ülalpool",
    "crossing_below": "Ületamine allpool",
    "total_records": "Rekordid kokku",
    "no_data_found": "Andmeid ei leitud",
    "show_more": "Näita rohkem",
    "show_less": "Näita vähem",
    "at": "aadressil",
    "trail": "Jälg",
    "order_pending": "Tellimus ootab",
    "target_price_less_market_greater_zero": "Sihthind peab olema väiksem kui turu vahemik ja suurem kui",
    "stop_loss_less_market_price_greater_zero": "Stop loss peab olema väiksem kui praegune turuhind ja suurem kui",
    "stop_loss_greater_market_range": "Stop loss peab olema suurem kui Market Range",
    "target_price_greater_market_price": "Sihthind peab olema suurem kui praegune turuhind",
    "watchlist_create": "Loo jälgimisnimekiri",
    "update": "Ajakohastamine",
    "delete_symbol": "Sümboli kustutamine",
    "are_sure_delete_symbol": "Kas sa oled kindel, et soovid selle sümboli kustutada?",
    "symbol_name": "Sümboli nimi",
    "edit_symbol": "Sümboli redigeerimine",
    "enter_watchlist_name": "Sisestage jälgimisnimekirja nimi",
    "search_title": "Otsi sümboleid",
    "b": "B",
    "s": "S",
    "a": "A",
    "username": "Kasutajanimi",
    "email_address": "E-posti aadress",
    "old_password_validation": "Vana salasõna on nõutav.",
    "old_password_greater_characters": "Vana salasõna ei tohi olla suurem kui 20 tähemärki",
    "new_password_validation": "Vajalik on uus salasõna",
    "confirm_password_is_required": "Vajalik on parooli kinnitamine.",
    "entered_password_not_match": "Sisestatud paroolid ei vasta. Palun proovige uuesti",
    "display_high_slash_low_grid_view": "Kõrge / madala kuvamine ruudustiku vaates",
    "display_spread_grid_view": "Leviku kuvamine ruudustiku vaates",
    "select_to_date": "Valige kuupäevaks",
    "select_from_date": "Valige kuupäevast alates",
    "select_show_order_slash_position_size_in": "Näita tellimus / positsiooni suurus In",
    "select_history_range": "Valige ajaloo vahemik",
    "lot_size_greater_than": "Partii suurus ei tohiks olla suurem kui",
    "select_time_zone": "Valige ajavöönd",
    "select_font_size": "Valige kirjasuurus",
    "select_mode_view_suits": "Valige teile sobiv vaatamisviis.",
    "selected": "Valitud",
    "basic_chart_view": "Põhiline diagrammi vaade",
    "grid_view": "Ruudustiku vaade",
    "multi_chart_view": "Mitme graafiku vaade",
    "settings_effect_trading_page": "Need seaded jõustuvad ainult kauplemislehel.",
    "market_watch": "Turu jälgimine",
    "favorite": "Lemmik",
    "one_click_trading": "Ühe klõpsuga kauplemine",
    "new_watchlist": "Uus jälgimisnimekiri",
    "maximum_5_watchlists": "Saate luua maksimaalselt 5 jälgimisnimekirja.",
    "new_watchlist_successfully": "Uus jälgimisnimekiri on edukalt lisatud",
    "delete_watchlist": "Kustuta jälgimisnimekiri",
    "delete_watchlist_successfully": "Jälgimisnimekiri on edukalt kustutatud",
    "edit_watchlist": "Muuda jälgimisnimekirja",
    "watchlist_updated_successfully": "Jälgimisnimekiri on edukalt uuendatud",
    "go_to_order": "Mine tellimusele",
    "search_filter_fx": "FX",
    "mon": "Mon",
    "tue": "Te",
    "wed": "Ke",
    "thu": "Thu",
    "fri": "Fri",
    "sat": "Sat",
    "sun": "Sun",
    "olivia_deo": "Olivia Deo",
    "risk": "Risk",
    "profit": "Kasum",
    "copiers": "Koopiamasinad",
    "win_rate": "Võidu määr",
    "greetings_des": "Tervitused, minu süsteem, mida ma siin esitan, nõuab järgmisi kontoseadistusi: 600usd--->0.01Lots Me teeme veeeery vähe tehinguid siin aastas, vahel 60-200 ametitest, Väga vajalikud ametitest nii, et - me hoida meie drawdown nii madal kui võimalik, võttes väga vajalikud ametitest. -Me sõita üle keskmiselt 30 südamikud kaubanduse kohta. *Luba kõik tehingud sellest süsteemist, et saavutada sarnaseid tulemusi. SO tunnete end teretulnud, kui te kasvatate oma kontot pidevalt meiega ja olete väga kannatlik.",
    "live_profit": "Elav kasum",
    "overall": "Üldine",
    "advanced_seats": "Täiustatud istmed",
    "trading": "Kauplemine",
    "drawDown": "DrawDown",
    "pips": "Pipsid",
    "include_unrealized_pnl": "Kaasa arvatud realiseerimata Pnl",
    "closed_trades_only": "Ainult suletud tehingud",
    "trades_volume": "Tehingute maht",
    "by_pair": "Paari kaupa",
    "best_worst": "Best-Worst",
    "ranking": "Edetabel",
    "paris": "Pariis",
    "trading_news": "Kauplemisuudised",
    "prev": "Eelmine",
    "next": "Järgmine",
    "follow": "Jälgi",
    "investment": "Investeeringud",
    "open_date_time": "Avatud kuupäev ja kellaaeg",
    "close_date_time": "Sulge kuupäev ja kellaaeg",
    "roll": "Rull",
    "total": "Kokku",
    "aud_slash_cad": "AUD/CAD",
    "position_list": "Positsioonide nimekiri",
    "trade_history": "Kaubanduse ajalugu",
    "completed": "Lõpetatud",
    "rejected": "Tagasilükatud",
    "pending_closed": "Oodates Suletud",
    "close_time_date": "Sulgemise aeg kuupäev",
    "status": "Staatus",
    "hedge_position": "Riskipositsioon",
    "partial_close": "Osaline sulgemine",
    "stop_loss_less_then": "Stop loss peab olema väiksem kui",
    "greater_then_zero": "ja suurem siis",
    "trailing_stop_greater_one": "Tagasiulatuv stop peab olema suurem kui",
    "greater_then": "Sihthind peab olema suurem kui",
    "stop_loss_greater_then": "Stop loss peab olema suurem kui",
    "target_price_less_then": "Sihthind peab olema väiksem kui",
    "volume_required": "Vajalik on maht.",
    "volume_less_then": "Maht peab olema väiksem kui",
    "PNL": "PNL",
    "lot_size_partial": "Partii suurus on vähem, et osaliselt sulgeda",
    "price_greater_then": "Hind peab olema suurem kui",
    "stop_loss_less_greater_then_zero": "Stop loss peab olema väiksem kui Price Level ja suurem kui 0",
    "trailing_stop_greate_then_zero": "Jälgimine Stop peab olema suurem kui",
    "stop_loss_trigger_price": "Stop loss peab olema suurem kui Trigger price",
    "date_range": "Kuupäeva vahemik",
    "from": "Alates",
    "to": "aadressile",
    "target_price_greater_then_zero": "Sihthind peab olema väiksem kui vallandamishind ja suurem kui",
    "target_price_market_range_greater_zero": "Sihthind peab olema väiksem kui Market Range ja suurem kui",
    "order_list": "Tellimuse nimekiri",
    "close_all_trades": "Sulge kõik ametid",
    "instrument_name": "Instrumendi nimi",
    "trade_logs": "Kauplemispäevikud",
    "transaction_ID": "Tehingu ID",
    "add_more_leader": "Lisa rohkem juhte",
    "total_Profit": "Kogukasum",
    "invested": "Investeeritud",
    "market101_guard_enabled": "Market101 Guard on lubatud",
    "excessive_losses": "Leader on ülemääraste kadude tõttu välja lülitatud.",
    "filter": "Filter",
    "remember_filters": "Pea meeles filtrid",
    "toggle": "Toggle",
    "matrix": "Maatriks",
    "select_all": "Valige kõik",
    "term": "Termin",
    "apply": "Rakenda",
    "clear_all": "Tühjenda kõik",
    "follow_more": "Jälgi rohkem",
    "go_to_dashboard": "Mine juhtpaneelile",
    "are_you_sure_stop_coping": "Kas olete kindel, et soovite selle meistri kopeerimise lõpetada?",
    "invested_amount": "Investeeritud summa",
    "max": "Max",
    "insufficient_funds": "Ebapiisavad vahendid kontol.",
    "enter_valid_amount": "Palun sisestage kehtiv summa.",
    "maximum_amount_allowed": "Maksimaalne lubatud summa on kuni",
    "available_capital": "Kättesaadav kapital",
    "copy_open_trades": "Kopeeri avatud tehinguid",
    "stop_following": "Lõpeta jälgimine",
    "leaders": "Juhid",
    "back_to_manual_trading": "Tagasi manuaalse kauplemise juurde",
    "advanced_stats": "Täiustatud statistika",
    "view_all": "Vaata kõiki",
    "roi": "ROI",
    "load_more": "Laadige rohkem",
    "powered_by": "Powered By",
    "act_trader": "Act Trader"
}


// WEBPACK FOOTER //
// ./src/plugins/lang/languages/et.js